import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Utils } from '../../common/utils';
import { environment } from '../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-summary-table',
  templateUrl: './summary-table.component.html',
  styleUrls: ['./summary-table.component.scss']
})
export class SummaryTableComponent {
  _data: any[];

  @Input()
  public get data(): any[] {
    return this._data;
  }
  public set data(value: any[]) {
    this._data = value.map((row) => {
      return {
        ...row,
        player: {
          ...row.player,
          image: this.sanitize.bypassSecurityTrustResourceUrl(row.player.image),
        }
      };
    });
  }

  utils = Utils;
  playerPosition: any;

  constructor(
    private translateService: TranslateService,
    private sanitize: DomSanitizer,
  ) {
    this.playerPosition = {
      1: this.translateService.instant('Point guard'),
      2: this.translateService.instant('Shooting guard'),
      3: this.translateService.instant('Small forward'),
      4: this.translateService.instant('Power forward'),
      5: this.translateService.instant('Center') // TODO: Should we call it 'pivot' too?
    };
  }


  onImageError($event) {
    $event.currentTarget.parentElement.classList.add('placeholder');
  }

  private getPlayerPosition(position: number) {
    return this.playerPosition[position];
  }

}
